import type { ReactNode } from 'react';
import { OVERLAY_ATTRIBUTE } from '../board-grid/useZoomPan';

/**
 * A bar of controls along the bottom of the picture, in the middle.
 *
 * Not at the mark in hand — the alternative, which the gym panel's scans page
 * still uses (see `AnchoredMarkPopover`). A panel standing at the mark covers
 * the wall around it, which is exactly the wall the setter is about to press
 * next, and it moves with every press; a bar with a fixed place is one the thumb
 * finds without looking, and it leaves the whole picture free. It is also there
 * before anything has been drawn, so what the *next* mark will be can be armed
 * in advance.
 *
 * Still on the picture rather than at the foot of the screen: it belongs to what
 * is being drawn, and the drawing is what fills the screen here. The side
 * padding keeps it clear of the corner the zoom's way out sits in.
 */
export function DockedBar({ children }: { children: ReactNode }) {
  return (
    <div
      className="pointer-events-none absolute inset-x-0 bottom-3 z-20 flex justify-center px-12"
      // Sat on the picture, not in it: the gesture that dragged the photo has no
      // claim on a press that lands here.
      {...{ [OVERLAY_ATTRIBUTE]: '' }}
    >
      <div className="pointer-events-auto">{children}</div>
    </div>
  );
}
